import React from "react";

export default function Web_Roadmap() {
  return (
    <div>
      <h1>What is Roadmap</h1>
      <p>
        Route: <code>/web/roadmap</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
